const jsonnetConfigService = {
    transformFinanceCalculator(financeCalculator) {
        return {
            ...financeCalculator,
            financeApplication: {
                ...(financeCalculator?.financeApplication || {}),
                availableSteps: financeCalculator?.financeApplication.availableSteps?.map((step) => step.slice(step.indexOf('|') + 1)) ?? [],
            },
        };
    },
};
export default jsonnetConfigService;
//# sourceMappingURL=jsonnetConfigService.js.map